import { render } from "./LogoFull.vue?vue&type=template&id=5b2bb544"
import script from "./LogoFull.vue?vue&type=script&lang=js"
export * from "./LogoFull.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__